import { render, staticRenderFns } from "./ContentAddBlogList.vue?vue&type=template&id=36b3737e&scoped=true"
import script from "./ContentAddBlogList.vue?vue&type=script&lang=js"
export * from "./ContentAddBlogList.vue?vue&type=script&lang=js"
import style0 from "./ContentAddBlogList.vue?vue&type=style&index=0&id=36b3737e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36b3737e",
  null
  
)

export default component.exports